import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { ThumbnailBig, FooterSection } from "@components";
import "./PedomanCorporateGovernance.scss";
import { CorporateGovernanceAPI, ShortDescriptionAPI } from "@api";
import { useTranslation } from "react-i18next";
import HeaderSection from "../../../common/components/Header/HeaderSection";
import LandingCardBox from "../../../common/components/LandingCardBox";
import { TitleComponent } from "../../../common/components/TitleComponent";
import MyMenu from "../MyMenu";

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const CorporateGovernanceContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`;

const H2 = styled.h2`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: #5e514d;
`;

const P = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
  color: #5e514d;
`;

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const PedomanCorporateGovernance = function () {
  const { t } = useTranslation();
  const [data, setdata] = useState({});
  const [isLoading, setisLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async function () {
    setisLoading(true);
    const { data } = await CorporateGovernanceAPI("pedoman");
    setdata(data.data);
    console.log(data.data);
    setisLoading(false);
  };

  return (
    <div>
      <TitleComponent title={data.judulBannerPedoman} />
      <Container>
        <Desktop>
        <ThumbnailBig
          title={isLoading ? "" : data.judulBannerPedoman}
          desc={isLoading ? "" : data.deskripsiBannerPedoman}
          img={isLoading ? "" : data.imageBannerDesktopPedoman}
        />
        </Desktop>
        <Mobile>
        <ThumbnailBig
          title={isLoading ? "" : data.judulBannerPedoman}
          desc={isLoading ? "" : data.deskripsiBannerPedoman}
          img={isLoading ? "" : data.imageBannerMobilePedoman}
        />
        </Mobile>
      </Container>

      <CorporateGovernanceContainer className="container-fluid">
        <div className="m-0 row d-flex align-items-start">
          <div className="p-0 col-lg-9 col-12">
            {isLoading
              ? []
              : data.blockDataPedoman.map((item) => {
                  return (
                    <div className="p-0 col-12">
                      <H2>{item.judulPedoman}</H2>
                      <P
                        dangerouslySetInnerHTML={{
                          __html: item.deskripsiPedoman,
                        }}
                      ></P>
                    </div>
                  );
                })}
          </div>
          <div className="d-none d-lg-block col">
            <MyMenu active={2} />
          </div>
        </div>
      </CorporateGovernanceContainer>
      <FooterSection currentPage={t("pedoman")} />
    </div>
  );
};

export default PedomanCorporateGovernance;
